// import React from 'react';
// import servicesData from '../../data/servicesData';
// import SectionsHead from './SectionsHead';


const Services = () => {

};

export default Services;